/*------------------------------------*/
/*        API CONFIG CONSTANTS        */
/*------------------------------------*/
export const CERTIFICATE_REPORTS_API_ENDPOINT = process.env.REACT_APP_CERTIFICATE_REPORTS_ENDPOINT;
export const CERTIFICATE_REPORTS_QUALITATIVE_API_ENDPOINT = process.env.REACT_APP_CERTIFICATE_REPORTS_QUALITATIVE_ENDPOINT;
export const CERTIFICATE_REPORTS_API_CLIENT_ID = process.env.REACT_APP_CERTIFICATE_REPORTS_CLIENT_ID;
export const CERTIFICATE_REPORTS_API_SECRET = process.env.REACT_APP_CERTIFICATE_REPORTS_SECRET;

export const HTTP_POST_METHOD = 'POST'
export const HTTP_HEADERS = {
    'Content-Type': 'application/json',
    'client_id': CERTIFICATE_REPORTS_API_CLIENT_ID,
    'client_secret': CERTIFICATE_REPORTS_API_SECRET
}

/*------------------------------------*/
/*          QUERY CONSTANTS           */
/*------------------------------------*/
export const ID_PREGUNTA = '20';
export const DEFAULT_QUERY_ORDER = 'NOMBRE ASC';
export const FACULTY_REPORT_QUERY_ORDER = 'DESCRIPCION ASC';
export const FACULTY_QUALITATIVE_REPORT_QUERY_ORDER = 'CUR_ACADEM, RESPUESTA ASC';
export const FACULTY_DOCID_QUERY_FIELDS = [
    'DOC_IDENTI',
    'NOMBRE',
];

export const CERTIFICATE_REPORTS_QUERY_FIELDS = [
    'DOC_IDENTI',
    'NOMBRE',
    'APELLIDO1',
    'APELLIDO2',
    'CUR_ACADEM',
    'DESC_CENTRO',
    'DESC_POBLACION',
    'DESC_TITULACION',
    'COD_ASIGNATURA',
    'DESC_ASIGNATURA',
    'NUM_RESP_PROF',
    'MED_RESP_PROF',
    'COD_GRUPO_SIMPLE'
];

export const FACULTY_REPORTS_QUERY_FIELDS = [
    'DOC_IDENTI',
    'NOMBRE',
    'APELLIDO1',
    'APELLIDO2',
    'CUR_ACADEM',
    'MODALIDAD',
    'SEGMENTO',
    'COD_ASIGNATURA',
    'DESC_ASIGNATURA',
    'COD_GRUPO_SIMPLE',
    'DESC_TITULACION',
    'PREGUNTA',
    'DESCRIPCION',
    'NUM_RESP_PROF',
    'MED_RESP_PROF',
    'NUM_RESP_DPTO_PROF',
    'MED_RESP_DPTO_PROF',
    'NUM_RESP_FACUL_PROF',
    'MED_RESP_FACUL_PROF',
    'NUM_RESP_UNIV_PROF',
    'MED_RESP_UNIV_PROF',
    'NUM_RESP_ANUALES',
    'MED_RESP_ANUALES'
];

/*------------------------------------*/
/*   CERTIFICATE CENTERS CONSTANTS    */
/*------------------------------------*/
export const MADRID_CENTER_NAME = 'Madrid';
export const CANARIAS_CENTER_NAME = 'Canarias';
export const VALENCIA_CENTER_NAME = 'Valencia';
export const ANDALUCIA_CENTER_NAME = 'Andalucía';